// extracted by mini-css-extract-plugin
module.exports = {"variantSelect":"VariantSelect-module--variant-select--1JuYL","selectLabel":"VariantSelect-module--select-label--1pcpG"};